import { services } from '@broadleaf/admin-components';

import AuroraHTMLField from "./AuroraHTMLField";
const { ComponentRegistrar } = services;

ComponentRegistrar.registerFieldComponent('HTML', AuroraHTMLField);
